// libraries.
import { Form } from 'react-bootstrap';

// styles.
import { WrapperFieldsToCorrect } from '@pages/DocumentAuditPage/modules/Georeferencing/components/styles';

interface SimpleInputFieldProps {
  label: string;
  name: string;
  type?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  error?: string;
  min?: number;
  max?: number;
  step?: string | number;
  disabled?: boolean;
}

export const SimpleInputField = ({
  label,
  name,
  type = 'text',
  value,
  onChange,
  placeholder = '',
  error,
  min,
  max,
  step,
  disabled = false,
}: SimpleInputFieldProps) => {
  return (
    <WrapperFieldsToCorrect>
      <Form.Group>
        <Form.Label className="form-label" htmlFor={name}>
          {label}
        </Form.Label>
        <Form.Control
          className="form-control"
          id={name}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          isInvalid={!!error}
          min={min}
          max={max}
          step={step}
          disabled={disabled}
        />
        {error && (
          <Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
            {error}
          </Form.Control.Feedback>
        )}
      </Form.Group>
    </WrapperFieldsToCorrect>
  );
};
